import {useEffect} from 'react'

interface IListSearchSituationDate {
  searchSituationDateStart: string
  setSearchSituationDateStart: (value: string) => void
  searchSituationDateEnd: string
  setSearchSituationDateEnd: (value: string) => void
  errorsSituationDate: string[]
  setErrorsSituationDate: (value: string[]) => void
}

const ListSearchSituationDate = ({
  searchSituationDateStart,
  setSearchSituationDateStart,
  searchSituationDateEnd,
  setSearchSituationDateEnd,
  errorsSituationDate,
  setErrorsSituationDate,
}: IListSearchSituationDate) => {
  useEffect(() => {
    if (searchSituationDateStart.length === 10 && searchSituationDateEnd.length === 10) {
      if (
        new Date(searchSituationDateStart).setHours(0, 0, 0, 0) >
        new Date(searchSituationDateEnd).setHours(0, 0, 0, 0)
      ) {
        const novosErros = [...errorsSituationDate]
        novosErros[0] = 'Data inicial deve ser menor que data final'
        novosErros[1] = 'Data inicial deve maior que data final'
        setErrorsSituationDate(novosErros)
        return
      }
    } else if (searchSituationDateStart.length === 10 && searchSituationDateEnd.length < 10) {
      const novosErros = [...errorsSituationDate]
      novosErros[0] = ''
      novosErros[1] = 'Data final deve ser informada'
      setErrorsSituationDate(novosErros)
      return
    } else if (searchSituationDateEnd.length === 10 && searchSituationDateStart.length < 10) {
      const novosErros = [...errorsSituationDate]
      novosErros[0] = 'Data inicial deve ser informada'
      novosErros[1] = ''
      setErrorsSituationDate(novosErros)
      return
    }
    const novosErros = [...errorsSituationDate]
    novosErros[0] = ''
    novosErros[1] = ''
    setErrorsSituationDate(novosErros)
  }, [searchSituationDateStart, searchSituationDateEnd])

  return (
    <>
      <div className='mb-5 row'>
        <div className='col-6'>
          <label className='form-label fs-6 fw-bold'>
            Pesquisar Por Data De Pagamento: Inicial
          </label>
          <input
            type='date'
            data-kt-user-table-filter='birthDate'
            className='form-control form-control-solid w-100'
            placeholder='Data inícial'
            value={searchSituationDateStart}
            onChange={(e) => setSearchSituationDateStart(e.target.value)}
            min='2015-12-31'
            maxLength={10}
          />
          {errorsSituationDate && errorsSituationDate.length > 0 && errorsSituationDate[0] ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block fs-6'>{errorsSituationDate[0]}</div>
            </div>
          ) : null}
        </div>
        <div className='col-6'>
          <label className='form-label fs-6 fw-bold'>Pesquisar Por Data De Pagamento: Final</label>
          <input
            type='date'
            data-kt-user-table-filter='dtEnd'
            className='form-control form-control-solid'
            placeholder='Data Final'
            value={searchSituationDateEnd}
            onChange={(e) => setSearchSituationDateEnd(e.target.value)}
            min='2015-12-31'
            maxLength={10}
          />
          {errorsSituationDate && errorsSituationDate.length > 0 && errorsSituationDate[1] ? (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block fs-6'>{errorsSituationDate[1]}</div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  )
}

export {ListSearchSituationDate}
